import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Label = styled.div`
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const FieldContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`
